import { Dispatch, SetStateAction, useEffect, useState } from "react";
import classNames from "classnames";
import { TextIcon } from "components/atoms/TextIcon";
import { Typography } from "components/atoms/Typography";
import { Lock } from "components/atoms/Icon";
import { EmptyCircle } from "components/atoms/Icon/EmptyCircle";
import { Select } from "components/atoms/Icon/Select";
import { YellowClock } from "components/atoms/Icon/YellowClock";
import { useScreenSize } from "hooks";
import { TAB_WIDTH, MOBILE_WIDTH } from "utils/constants";
import { ButtonsByContentObjectTypes } from "../ButtonsByContentObjectTypes";
import "./index.scss";

interface IProps {
  index: number;
  textIconLabel: string;
  iconType?: undefined | "yellow-timer" | "select" | "empty-circle" | "lock";
  btnLabel?: string;
  middleLabel?: string | null;
  badge?: string;
  isBtn?: boolean;
  isSecondBtn?: boolean;
  secondBtnLabel?: string;
  isHideButtons?: boolean;
  handlePrimaryBtnClick?: () => any;
  handleSecondaryBtnClick?: () => any;
  handleRefreshCourseIndex?: () => any;
  theme: "light" | "dark";
  contentObjectType?: string;
  type?: any;
  title?: string;
  setCourseWorkPage?: Dispatch<SetStateAction<number>>;
  status: string;
  isLocked: boolean;
  drillSmartResult?: any;
}

export const CourseIndexHomeWorkRow = ({
  index,
  textIconLabel,
  iconType,
  btnLabel,
  middleLabel,
  badge,
  isSecondBtn,
  secondBtnLabel,
  isHideButtons,
  isBtn,
  theme,
  handlePrimaryBtnClick,
  handleSecondaryBtnClick,
  handleRefreshCourseIndex,
  contentObjectType,
  type,
  title,
  setCourseWorkPage,
  status,
  isLocked,
  drillSmartResult,
}: IProps) => {
  const [responsiveMiddleLabel, setResponsiveMiddleLabel] = useState("");

  useEffect(() => {
    if (middleLabel && middleLabel.length > 5) {
      setResponsiveMiddleLabel(middleLabel.slice(0, 5) + "...");
    }
  }, []);

  const screen = useScreenSize();

  const renderStatusIcon = () => {
    if (iconType === "yellow-timer") return <YellowClock />;
    if (iconType === "select") return <Select />;
    if (iconType === "empty-circle") return <EmptyCircle theme={theme} />;
    if (iconType === "lock") return <Lock theme={theme} />;
    return <EmptyCircle theme={theme} />;
  };

  const iconTextSectionContent = badge ? (
    <>
      <div className="icon-content icon-content-centered">
        {renderStatusIcon()}
      </div>
      <div className="name-badge-column">
        <h6 className="text-icon-label-reverse">{textIconLabel}</h6>
        <div className="badge-wrapper">
          <Typography variant="h8Med" label={badge} styles="badge-text" />
        </div>
      </div>
    </>
  ) : (
    <>
      <TextIcon
        label={textIconLabel}
        icon={true}
        isReverse={true}
        iconType={iconType}
        isTabStyle={true}
        theme={theme}
      />
    </>
  );

  return (
    <div
      className={classNames(
        "course-index-class-home-work-row-wrapper",
        {
          "bg-white": index % 2 === 0,
          "bg-blue": index % 2 !== 0,
          "bg-gray": iconType === "lock",
        },
        screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH
          ? "tab-style"
          : ""
      )}
    >
      {screen.width <= 1550 ? (
        <div className="home-tab-size-wrapper">
          <div
            className={classNames({
              "icon-text-section": true,
              "icon-text-section-with-badge": !!badge,
              "text-gray": iconType === "lock",
            })}
          >
            {iconTextSectionContent}
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </div>
      ) : (
        <>
          <div
            className={classNames({
              "icon-text-section": true,
              "icon-text-section-with-badge": !!badge,
              "text-gray": iconType === "lock",
            })}
          >
            {iconTextSectionContent}
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </>
      )}
      <div
        className={classNames(
          "btn-section",
          screen.width <= 810 || (screen.width > 1024 && screen.width < 1226)
            ? "course-index-tab-btn-handle"
            : ""
        )}
      >
        <ButtonsByContentObjectTypes
          status={status}
          isLocked={isLocked}
          contentObjectType={contentObjectType}
          drillSmartResult={drillSmartResult}
          handlePrimaryBtnClick={handlePrimaryBtnClick}
          handleSecondaryBtnClick={handleSecondaryBtnClick}
        />
      </div>
    </div>
  );
};
